import actions from '../action/product_template'

export default {
  actions,
  state: {
  },
  mutations: {
  },
}
